
import { Component, Input } from '@angular/core';
import { IconserviceService } from '../icon-service/iconservice.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { iconProofRead } from '../proof-reader/icon-proofread';
import { iconessayChecker } from '../easy-checker/icon-eaasy';
import { iconFooter } from '../footer/iconimages';
import { iconGrammarChecker } from '../grammarchecker/icon-grammarchecker';
import { iconSentenceChecker } from '../sentence-checker/icons-sentence-checket';
import { iconAllTools } from '../Tools/all-tools/icons-all-tools';
import { iconsPlagiarism } from '../plagiarism/icons-plagiarism';
import { helpingToolsIcons } from '../contact-us/helping-tolls-icons';
import { modalsIcon } from '../language/modals-icons';
import { headerIcon } from '../header/header-icons';
import { iconHome } from '../home/home-icons';
import { accountLogIcons } from '../signup/account-log-icons';

@Component({
  selector: 'app-icons-free-tools',
  standalone: true,
  imports: [],
  templateUrl: './icons-free-tools.component.html',
  styleUrl: './icons-free-tools.component.css'
})
export class IconsFreeToolsComponent {
   safeHtmlContent: string;
      images: { [key: string]: SafeHtml } = {};
      @Input() name: string = '';
      sanitizedIcon: any;
      proofReader:any
      essayChecker:any;
      footerIcon:any;
      grammarcheckIcon:any;
      sentencecheckIcon:any;
      allToolsIcon:any;
      plagiarismIcon:any;
     helpingToolsIcons:any;
     modalsIcons:any;
     headericons:any;
     homemages:any;
     accounticon:any;




     constructor(
        private IconService: IconserviceService

      ) {

      }
        ngOnInit() {





          const proofreadIcon = iconProofRead[this.name] || '';
          this.proofReader = this.IconService.sanitize(proofreadIcon);

          const essayCheckerIcon = iconessayChecker[this.name] || '';
          this.essayChecker = this.IconService.sanitize(essayCheckerIcon);

           const footer = iconFooter[this.name] || '';
          this.footerIcon = this.IconService.sanitize(footer);

          const grammar = iconGrammarChecker[this.name] || '';
          this.grammarcheckIcon = this.IconService.sanitize(grammar);

          const sentence = iconSentenceChecker[this.name] || '';
          this.sentencecheckIcon = this.IconService.sanitize(sentence);

          const tools = iconAllTools[this.name] || '';
          this.allToolsIcon = this.IconService.sanitize(tools);

          const plagiarism = iconsPlagiarism[this.name] || '';
          this.plagiarismIcon = this.IconService.sanitize(plagiarism);

          const helpingTools = helpingToolsIcons [this.name] || '';
          this.helpingToolsIcons = this.IconService.sanitize(helpingTools);

          const modals = modalsIcon [this.name] || '';
          this.modalsIcons = this.IconService.sanitize(modals);

          const iconheaderpics = headerIcon [this.name] || '';
          this.headericons = this.IconService.sanitize(iconheaderpics);

          const iconhomepics = iconHome [this.name] || '';
          this.homemages = this.IconService.sanitize(iconhomepics);



          const accountpics = accountLogIcons [this.name] || '';
          this.accounticon = this.IconService.sanitize(accountpics);


        }

}
